import getClientConfigValue from "../../client/getClientConfigValue";
import { Cloudinary } from "@cloudinary/url-gen";

export default () =>
  new Cloudinary({
    cloud: {
      cloudName: SERVER
        ? process.env.CLIENT_ASSETS_CLOUD_NAME
        : getClientConfigValue("ASSETS_CLOUD_NAME")
    },
    url: {
      secureDistribution: SERVER
        ? process.env.CLIENT_ASSETS_SECURE_DISTRIBUTION_HOST
        : getClientConfigValue("ASSETS_SECURE_DISTRIBUTION_HOST"),
      privateCdn: true
    }
  });
